import { alpha } from "@commonlibs";
import { css } from "styled-components";
import { getTypographyStyle } from "./util/getTypographyStyle";

export const SelectStyles = css(
    ({ theme: { palette, spacing, borderRadius, border } }) => css`
        //Base styles
        .Select {
            ${getTypographyStyle("body2Strong")};

            .SelectDisplay {
                border: ${palette.components.input.border};
                border-radius: ${borderRadius};
                padding: ${spacing.all(4, 5)};
                .Placeholder {
                    color: ${palette.components.input.placeholderColor};
                }
                .SelectDropdown .Icon {
                    color: ${palette.gray[650]};
                }
            }

            .SelectMenu {
                box-shadow: none;
                border: ${border.sm};
                border-radius: ${borderRadius};
                padding: 0;
                margin-top: 0.125rem;
            }

            .SelectItem {
                ${getTypographyStyle("body2Regular")};

                display: flex;
                align-items: center;
                padding: ${spacing.all(2, 5, 2)};

                cursor: pointer;

                &:hover {
                    background-color: ${alpha(palette.primary, 0.12)};
                }

                &.Selected {
                    background-color: ${alpha(palette.primary, 0.3)};
                    ${getTypographyStyle("body2Strong")};
                }
            }
        }

        .FormControl {
            .SelectDisplay {
                height: 3.75rem;
            }
            .SelectItem {
                height: 3.75rem;
                display: flex;
                align-items: center;
            }

            &.Readonly {
                .SelectDisplay,
                .SelectDropdown .Icon {
                    ${getTypographyStyle("body2Strong")};
                }
            }
        }
    `,
);
